import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { toastEmmit } from "../../../../Helper/Toastr";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { 
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";

export default function ChangePassword() {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [oldPass, setOldPass] = useState();
  const [newPass, setNewPass] = useState(true);
  const [confPass, setConfPass] = useState();
  const [showErr, setShowErr] = useState();
  const [showHideOld, setShowHideOld] = useState(true);
  const [showHideConf, setShowHideConf] = useState(true);
  const [showHideNew, setShowHideNew] = useState(true);

  const changeOldPassword = (e) => {
    setOldPassword(e);

    if (showErr) {
      if (e === "") {
        setOldPass("Old Password is required");
        return;
      }

      setOldPass();
    }
  };

  const changeNewPassword = (e) => {
    setNewPassword(e); 

    if (e.length === 0) {
      setNewPass("New Password is required");
    } else if (e.length < 6) {
      setNewPass("Password should be at least 6 characters long");
    } else {
      setNewPass(""); 
    } 
  };

  const changeConfirmPassword = (e) => {
    
    setConfirmPassword(e);

    if (e === "") {
      setConfPass("Confirm Password is required");
    } else if (e !== newPassword) {
      setConfPass("Password Mismatch! Recheck");
    } else {
      setConfPass(""); 
    }
 
  };

  const checkBlank = () => {
    let val = false;
    if (!oldPassword) {
      setOldPass("Old Password is required");
      val = true;
    }

    if (!newPassword) {
      setNewPass("New Password is required");
      val = true;
    }

    if (!confirmPassword) {
      setConfPass("Confirm Password is required");
      val = true;
    }
    return val;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowErr(true);

    if (checkBlank()) return;

    if (confirmPassword !== newPassword) {
      setConfPass("Password Mismatch ! Recheck");
      return;
    }

    if (newPassword.length < 6) {
      setNewPass("Password should be atleast 6 characters long");
      return;
    }

    if (oldPassword === newPassword) {
      showErrorAlert("New password and Old password are same");
      // toastEmmit("New password and Old password are same", "error");
      return;
    }

    const data = {
      old_password: oldPassword,
      password: newPassword,
      confirm_password: confirmPassword
    };

    PostService(API_URL.CHANGE_PASSWORD, data).then((res) => {
      console.log(res);
      if (res?.status === 200) {
        showSuccessAlert(res?.data?.message, ()=>{
          navigate("/panel/dashboard");
        });
        // toastEmmit(res?.data?.message, "success");
      } else {
        showErrorAlert(res?.data?.message)
        // toastEmmit(res?.data?.message, "error");
      }
    });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Change Password</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Change Password</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <form
                    onSubmit={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    <div className="row">
                      <div className="col-md-4 ">
                        <div className="form-group">
                          <label htmlFor="old_password" className="form-label">
                            Old Password
                          </label>
                          <div className="input-group">
                            <input
                              formcontrolname="old_password"
                              placeholder="Old Password"
                              className="form-control ng-untouched ng-pristine ng-invalid"
                              type={showHideOld ? "password" : "text"}
                              onChange={(e) => {
                                changeOldPassword(e.target.value);
                              }}
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span
                                  onClick={() => {
                                    setShowHideOld(!showHideOld);
                                  }}
                                  className={
                                    showHideOld
                                    ? "icon-lock menu-icon"
                                    : "icon-eye menu-icon"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          {oldPass && <span className="error">{oldPass}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="old_password" className="form-label">
                            New Password
                          </label>
                          <div className="input-group">
                            <input
                              formcontrolname="password"
                              placeholder="New Password"
                              className="form-control ng-untouched ng-pristine ng-invalid"
                              type={showHideNew ? "password" : "text"}
                              onChange={(e) => {
                                changeNewPassword(e.target.value);
                              }}
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span
                                  onClick={() => {
                                    setShowHideNew(!showHideNew);
                                  }}
                                  className={
                                    showHideNew
                                      ? "icon-lock menu-icon"
                                      : "icon-eye menu-icon"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          {newPass && <span className="error">{newPass}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="c_pass" className="form-label">
                            Confirm Password
                          </label>
                          <div className="input-group">
                            <input
                              formcontrolname="confirm_password"
                              placeholder="Confirm Password"
                              className="form-control ng-untouched ng-pristine ng-invalid"
                              type={showHideConf ? "password" : "text"}
                              onChange={(e) => {
                                changeConfirmPassword(e.target.value);
                              }}
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span
                                  onClick={() => {
                                    setShowHideConf(!showHideConf);
                                  }}
                                  className={
                                    showHideConf
                                    ? "icon-lock menu-icon"
                                    : "icon-eye menu-icon"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          {confPass && (
                            <span className="error">{confPass}</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col-12">
                        <button
                          type="submit"
                          className="btn btn-primary px-2 mt-3 w-100"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
